import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { BOOKING_LINK } from "../data/assets";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [bookingLink, setBookingLink] = useState(BOOKING_LINK);
  const [videoOverrides, setVideoOverrides] = useState({});
  const [chapterVideos, setChapterVideos] = useState({});
  const [coachEmail, setCoachEmail] = useState("");
  const [featured, setFeatured] = useState({ video: "", title: "", note: "" });
  const [weekly, setWeekly] = useState({ drills: [], tipVideo: "", tipTitle: "" });
  const [helpVideos, setHelpVideos] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/coach/settings`);
      if (data) {
        setBookingLink(data.booking_link || BOOKING_LINK);
        setVideoOverrides(data.video_overrides || {});
        setChapterVideos(data.chapter_videos || {});
        setCoachEmail(data.coach_email || "");
        setFeatured({
          video: data.featured_video || "",
          title: data.featured_title || "",
          note: data.featured_note || "",
        });
        setWeekly({
          drills: data.weekly_drills || [],
          tipVideo: data.weekly_tip_video || "",
          tipTitle: data.weekly_tip_title || "",
        });
        setHelpVideos(data.help_videos || []);
      }
    } catch (e) {
      // keep defaults if offline
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ bookingLink, videoOverrides, chapterVideos, coachEmail, featured, weekly, helpVideos, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
